/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageDto } from '../../models/language-dto';

export interface LocalizationLanguagesGet$Json$Params {
}

export function localizationLanguagesGet$Json(http: HttpClient, rootUrl: string, params?: LocalizationLanguagesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageDto>>> {
  const rb = new RequestBuilder(rootUrl, localizationLanguagesGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LanguageDto>>;
    })
  );
}

localizationLanguagesGet$Json.PATH = '/localization/languages';
